import React from "react";
import QuoteList from "../../components/Pages/Quotes/List/List";

const Quotes = () => {
  return (
    <div>
      <QuoteList />
    </div>
  );
};

export default Quotes;
